import { AssessmentContext } from "@/contexts/AssessmentContext";
import { useContext } from "react";

export function useAssessment() {
  const context = useContext(AssessmentContext);

  if (!context) {
    throw new Error('useAssessment deve ser usado dentro de um AssessmentProvider');
  }

  return context;
}
